import clsx from 'clsx'
import React from 'react'

export const Tabs = ({ options, onChange, large, active }) => {
  return (
    <div className="flex border-b border-gray-300 mt-6 mb-2">
      {options.map(option => (
        <div
          key={option.value}
          className={clsx(
            'flex cursor-pointer text-lg font-semibold justify-center px-3 ml-2 md:ml-6 text-gray-600',
            active === option.value && 'border-b-2 border-green-600 text-gray-900'
          )}
        >
          <span
            onClick={() => onChange(option.value)}
            className={clsx(active !== option.value && 'text-gray-400', large && 'md:text-2xl font-semibold text-md')}
          >
            {option.name}
          </span>
        </div>
      ))}
    </div>
  )
}

export default Tabs
